const SvgPauseIcon = () => {
  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none">
      <rect
        x="0.112305"
        y="0.112305"
        width="34.7755"
        height="34.7755"
        fill="url(#pattern0_249_11616)"
      />
      <defs>
        <pattern
          id="pattern0_249_11616"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_249_11616" transform="scale(0.0111111)" />
        </pattern>
        <image
          id="image0_249_11616"
          width="90"
          height="90"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABrElEQVR4nO3csU4CURhE4alY30EeUeEtRSr0UQz2Y0y2sAET/IvxMJPcakPynWQ3dFfquq7ruq7ruq7ruq7rru1B0l7SUdKnJF84389eJe0kLXfkGdlW0vuVGF84b+tv6Z6xN+eWKP+IW8Cese3/EOX1PIM9YzsOhB3AnrGdB8LOYM/YPHSoHmyYwzzYMId5sGEO82DDHObBhjnMgw1zmAcb5jAPNsxhHmyYwzzYMId5sGEO82DDHObBhjnMgw1zmAcb5jAPNsxhHmyYwzzYMId5sGEO82DDHObBhjnMgw1zmAcb5jAPNsxhHmyYwzzYMId5sGEO82DDHObBhjnMgw1zmAcb5jAPNsxhHmyYwzzYMId5sGEO82DDHObBhjnMgw1zmAcb5jAPNsxhHmyYwzzYMId5sGEO82DDHObBhjnMgw1zmAcb5jAPNsxhHmyYwzzYMId5sGEO82DDHObBhjnME3X92QfYg73Q7xjmGdtuIOwJ7Bnbsl6cemvUSdIG7Bnd9sa4k6THO/CMbllvqT388od0lvSyfp6bO/J0Xdd1Xdd1Xdd1Xdfpv+8L78sAgmFBNlIAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};

export default SvgPauseIcon;
